export default {
    ABOUT_DESCRIPTION_V2: 'ABOUT_DESCRIPTION_V2',
    ABOUT_STORE_POLICIES: 'ABOUT_STORE_POLICIES',
    ABOUT_VIDEO: 'ABOUT_VIDEO',
    BUSINESS_DETAILS: 'BUSINESS_DETAILS',
    CONTACT_SELLER: 'CONTACT_SELLER',
    ITEMS_CAROUSEL: 'ITEMS_CAROUSEL',
    ITEMS_GRID: 'ITEMS_GRID',
    LOADING_SPINNER: 'LOADING_SPINNER',
    MARKETING_BANNER: 'MARKETING_BANNER',
    MARKETING_BANNER_V2: 'MARKETING_BANNER_V2',
    NAVIGATION_CAROUSEL: 'NAVIGATION_CAROUSEL',
    NAVIGATION_CAROUSEL_V2: 'NAVIGATION_CAROUSEL_V2',
    SEARCH_STORE_V2: 'SEARCH_STORE_V2',
    SEEK_SURVEY_WEB: 'SEEK_SURVEY_WEB',
    SELLER_COMMS: 'SELLER_COMMS',
    SEO_METADATA: 'SEO_METADATA',
    SORT_ITEMS_SELECTION: 'SORT_ITEMS_SELECTION',
    STATUS_MESSAGE: 'STATUS_MESSAGE',
    STORE_CATEGORIES: 'STORE_CATEGORIES',
    STORE_CATEGORIES_V2: 'STORE_CATEGORIES_V2',
    STORE_INFORMATION: 'STORE_INFORMATION',
    STORE_TABS: 'STORE_TABS'
};
